var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6826,
    r: 20,
    fill: "#F9FCFF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 15.1158H24.1667V12.4658C23.4081 12.3869 22.646 12.348 21.8833 12.3491C19.6167 12.3491 18.0667 13.7325 18.0667 16.2658V18.4491H15.5083V21.4158H18.0667V29.0158H21.1333V21.4158H23.6833L24.0667 18.4491H21.1333V16.5575C21.1333 15.6825 21.3667 15.1158 22.6 15.1158Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.96b3f4e56123f2ba7d1b3cd0ad10dbe4.svg";
export { ForwardRef as ReactComponent };